// GENERATED. Do not hand-edit.
// Static per-language highlight.js module map, enabling register-on-first-use
// instead of eagerly registering all languages via highlight.js/lib/index.js.
// It also carries the alias table below, derived from highlight.js/lib/index.js's
// registration data (including its alias-collision registration order).
// Regenerate: re-derive from the installed highlight.js/lib/languages/*.js modules
// and highlight.js/lib/index.js's registration order.

import _1cLang from "highlight.js/lib/languages/1c.js";
import abnfLang from "highlight.js/lib/languages/abnf.js";
import accesslogLang from "highlight.js/lib/languages/accesslog.js";
import actionscriptLang from "highlight.js/lib/languages/actionscript.js";
import adaLang from "highlight.js/lib/languages/ada.js";
import angelscriptLang from "highlight.js/lib/languages/angelscript.js";
import apacheLang from "highlight.js/lib/languages/apache.js";
import applescriptLang from "highlight.js/lib/languages/applescript.js";
import arcadeLang from "highlight.js/lib/languages/arcade.js";
import arduinoLang from "highlight.js/lib/languages/arduino.js";
import armasmLang from "highlight.js/lib/languages/armasm.js";
import asciidocLang from "highlight.js/lib/languages/asciidoc.js";
import aspectjLang from "highlight.js/lib/languages/aspectj.js";
import autohotkeyLang from "highlight.js/lib/languages/autohotkey.js";
import autoitLang from "highlight.js/lib/languages/autoit.js";
import avrasmLang from "highlight.js/lib/languages/avrasm.js";
import awkLang from "highlight.js/lib/languages/awk.js";
import axaptaLang from "highlight.js/lib/languages/axapta.js";
import bashLang from "highlight.js/lib/languages/bash.js";
import basicLang from "highlight.js/lib/languages/basic.js";
import bnfLang from "highlight.js/lib/languages/bnf.js";
import brainfuckLang from "highlight.js/lib/languages/brainfuck.js";
import cLang from "highlight.js/lib/languages/c.js";
import c_likeLang from "highlight.js/lib/languages/c-like.js";
import calLang from "highlight.js/lib/languages/cal.js";
import capnprotoLang from "highlight.js/lib/languages/capnproto.js";
import ceylonLang from "highlight.js/lib/languages/ceylon.js";
import cleanLang from "highlight.js/lib/languages/clean.js";
import clojureLang from "highlight.js/lib/languages/clojure.js";
import clojure_replLang from "highlight.js/lib/languages/clojure-repl.js";
import cmakeLang from "highlight.js/lib/languages/cmake.js";
import coffeescriptLang from "highlight.js/lib/languages/coffeescript.js";
import coqLang from "highlight.js/lib/languages/coq.js";
import cosLang from "highlight.js/lib/languages/cos.js";
import cppLang from "highlight.js/lib/languages/cpp.js";
import crmshLang from "highlight.js/lib/languages/crmsh.js";
import crystalLang from "highlight.js/lib/languages/crystal.js";
import csharpLang from "highlight.js/lib/languages/csharp.js";
import cspLang from "highlight.js/lib/languages/csp.js";
import cssLang from "highlight.js/lib/languages/css.js";
import dLang from "highlight.js/lib/languages/d.js";
import dartLang from "highlight.js/lib/languages/dart.js";
import delphiLang from "highlight.js/lib/languages/delphi.js";
import diffLang from "highlight.js/lib/languages/diff.js";
import djangoLang from "highlight.js/lib/languages/django.js";
import dnsLang from "highlight.js/lib/languages/dns.js";
import dockerfileLang from "highlight.js/lib/languages/dockerfile.js";
import dosLang from "highlight.js/lib/languages/dos.js";
import dsconfigLang from "highlight.js/lib/languages/dsconfig.js";
import dtsLang from "highlight.js/lib/languages/dts.js";
import dustLang from "highlight.js/lib/languages/dust.js";
import ebnfLang from "highlight.js/lib/languages/ebnf.js";
import elixirLang from "highlight.js/lib/languages/elixir.js";
import elmLang from "highlight.js/lib/languages/elm.js";
import erbLang from "highlight.js/lib/languages/erb.js";
import erlangLang from "highlight.js/lib/languages/erlang.js";
import erlang_replLang from "highlight.js/lib/languages/erlang-repl.js";
import excelLang from "highlight.js/lib/languages/excel.js";
import fixLang from "highlight.js/lib/languages/fix.js";
import flixLang from "highlight.js/lib/languages/flix.js";
import fortranLang from "highlight.js/lib/languages/fortran.js";
import fsharpLang from "highlight.js/lib/languages/fsharp.js";
import gamsLang from "highlight.js/lib/languages/gams.js";
import gaussLang from "highlight.js/lib/languages/gauss.js";
import gcodeLang from "highlight.js/lib/languages/gcode.js";
import gherkinLang from "highlight.js/lib/languages/gherkin.js";
import glslLang from "highlight.js/lib/languages/glsl.js";
import gmlLang from "highlight.js/lib/languages/gml.js";
import goLang from "highlight.js/lib/languages/go.js";
import goloLang from "highlight.js/lib/languages/golo.js";
import gradleLang from "highlight.js/lib/languages/gradle.js";
import groovyLang from "highlight.js/lib/languages/groovy.js";
import hamlLang from "highlight.js/lib/languages/haml.js";
import handlebarsLang from "highlight.js/lib/languages/handlebars.js";
import haskellLang from "highlight.js/lib/languages/haskell.js";
import haxeLang from "highlight.js/lib/languages/haxe.js";
import hspLang from "highlight.js/lib/languages/hsp.js";
import htmlbarsLang from "highlight.js/lib/languages/htmlbars.js";
import httpLang from "highlight.js/lib/languages/http.js";
import hyLang from "highlight.js/lib/languages/hy.js";
import inform7Lang from "highlight.js/lib/languages/inform7.js";
import iniLang from "highlight.js/lib/languages/ini.js";
import irpf90Lang from "highlight.js/lib/languages/irpf90.js";
import isblLang from "highlight.js/lib/languages/isbl.js";
import javaLang from "highlight.js/lib/languages/java.js";
import javascriptLang from "highlight.js/lib/languages/javascript.js";
import jboss_cliLang from "highlight.js/lib/languages/jboss-cli.js";
import jsonLang from "highlight.js/lib/languages/json.js";
import juliaLang from "highlight.js/lib/languages/julia.js";
import julia_replLang from "highlight.js/lib/languages/julia-repl.js";
import kotlinLang from "highlight.js/lib/languages/kotlin.js";
import lassoLang from "highlight.js/lib/languages/lasso.js";
import latexLang from "highlight.js/lib/languages/latex.js";
import ldifLang from "highlight.js/lib/languages/ldif.js";
import leafLang from "highlight.js/lib/languages/leaf.js";
import lessLang from "highlight.js/lib/languages/less.js";
import lispLang from "highlight.js/lib/languages/lisp.js";
import livecodeserverLang from "highlight.js/lib/languages/livecodeserver.js";
import livescriptLang from "highlight.js/lib/languages/livescript.js";
import llvmLang from "highlight.js/lib/languages/llvm.js";
import lslLang from "highlight.js/lib/languages/lsl.js";
import luaLang from "highlight.js/lib/languages/lua.js";
import makefileLang from "highlight.js/lib/languages/makefile.js";
import markdownLang from "highlight.js/lib/languages/markdown.js";
import mathematicaLang from "highlight.js/lib/languages/mathematica.js";
import matlabLang from "highlight.js/lib/languages/matlab.js";
import maximaLang from "highlight.js/lib/languages/maxima.js";
import melLang from "highlight.js/lib/languages/mel.js";
import mercuryLang from "highlight.js/lib/languages/mercury.js";
import mipsasmLang from "highlight.js/lib/languages/mipsasm.js";
import mizarLang from "highlight.js/lib/languages/mizar.js";
import mojoliciousLang from "highlight.js/lib/languages/mojolicious.js";
import monkeyLang from "highlight.js/lib/languages/monkey.js";
import moonscriptLang from "highlight.js/lib/languages/moonscript.js";
import n1qlLang from "highlight.js/lib/languages/n1ql.js";
import nginxLang from "highlight.js/lib/languages/nginx.js";
import nimLang from "highlight.js/lib/languages/nim.js";
import nixLang from "highlight.js/lib/languages/nix.js";
import node_replLang from "highlight.js/lib/languages/node-repl.js";
import nsisLang from "highlight.js/lib/languages/nsis.js";
import objectivecLang from "highlight.js/lib/languages/objectivec.js";
import ocamlLang from "highlight.js/lib/languages/ocaml.js";
import openscadLang from "highlight.js/lib/languages/openscad.js";
import oxygeneLang from "highlight.js/lib/languages/oxygene.js";
import parser3Lang from "highlight.js/lib/languages/parser3.js";
import perlLang from "highlight.js/lib/languages/perl.js";
import pfLang from "highlight.js/lib/languages/pf.js";
import pgsqlLang from "highlight.js/lib/languages/pgsql.js";
import phpLang from "highlight.js/lib/languages/php.js";
import php_templateLang from "highlight.js/lib/languages/php-template.js";
import plaintextLang from "highlight.js/lib/languages/plaintext.js";
import ponyLang from "highlight.js/lib/languages/pony.js";
import powershellLang from "highlight.js/lib/languages/powershell.js";
import processingLang from "highlight.js/lib/languages/processing.js";
import profileLang from "highlight.js/lib/languages/profile.js";
import prologLang from "highlight.js/lib/languages/prolog.js";
import propertiesLang from "highlight.js/lib/languages/properties.js";
import protobufLang from "highlight.js/lib/languages/protobuf.js";
import puppetLang from "highlight.js/lib/languages/puppet.js";
import purebasicLang from "highlight.js/lib/languages/purebasic.js";
import pythonLang from "highlight.js/lib/languages/python.js";
import python_replLang from "highlight.js/lib/languages/python-repl.js";
import qLang from "highlight.js/lib/languages/q.js";
import qmlLang from "highlight.js/lib/languages/qml.js";
import rLang from "highlight.js/lib/languages/r.js";
import reasonmlLang from "highlight.js/lib/languages/reasonml.js";
import ribLang from "highlight.js/lib/languages/rib.js";
import roboconfLang from "highlight.js/lib/languages/roboconf.js";
import routerosLang from "highlight.js/lib/languages/routeros.js";
import rslLang from "highlight.js/lib/languages/rsl.js";
import rubyLang from "highlight.js/lib/languages/ruby.js";
import ruleslanguageLang from "highlight.js/lib/languages/ruleslanguage.js";
import rustLang from "highlight.js/lib/languages/rust.js";
import sasLang from "highlight.js/lib/languages/sas.js";
import scalaLang from "highlight.js/lib/languages/scala.js";
import schemeLang from "highlight.js/lib/languages/scheme.js";
import scilabLang from "highlight.js/lib/languages/scilab.js";
import scssLang from "highlight.js/lib/languages/scss.js";
import shellLang from "highlight.js/lib/languages/shell.js";
import smaliLang from "highlight.js/lib/languages/smali.js";
import smalltalkLang from "highlight.js/lib/languages/smalltalk.js";
import smlLang from "highlight.js/lib/languages/sml.js";
import sqfLang from "highlight.js/lib/languages/sqf.js";
import sqlLang from "highlight.js/lib/languages/sql.js";
import sql_moreLang from "highlight.js/lib/languages/sql_more.js";
import stanLang from "highlight.js/lib/languages/stan.js";
import stataLang from "highlight.js/lib/languages/stata.js";
import step21Lang from "highlight.js/lib/languages/step21.js";
import stylusLang from "highlight.js/lib/languages/stylus.js";
import subunitLang from "highlight.js/lib/languages/subunit.js";
import swiftLang from "highlight.js/lib/languages/swift.js";
import taggerscriptLang from "highlight.js/lib/languages/taggerscript.js";
import tapLang from "highlight.js/lib/languages/tap.js";
import tclLang from "highlight.js/lib/languages/tcl.js";
import thriftLang from "highlight.js/lib/languages/thrift.js";
import tpLang from "highlight.js/lib/languages/tp.js";
import twigLang from "highlight.js/lib/languages/twig.js";
import typescriptLang from "highlight.js/lib/languages/typescript.js";
import valaLang from "highlight.js/lib/languages/vala.js";
import vbnetLang from "highlight.js/lib/languages/vbnet.js";
import vbscriptLang from "highlight.js/lib/languages/vbscript.js";
import vbscript_htmlLang from "highlight.js/lib/languages/vbscript-html.js";
import verilogLang from "highlight.js/lib/languages/verilog.js";
import vhdlLang from "highlight.js/lib/languages/vhdl.js";
import vimLang from "highlight.js/lib/languages/vim.js";
import x86asmLang from "highlight.js/lib/languages/x86asm.js";
import xlLang from "highlight.js/lib/languages/xl.js";
import xmlLang from "highlight.js/lib/languages/xml.js";
import xqueryLang from "highlight.js/lib/languages/xquery.js";
import yamlLang from "highlight.js/lib/languages/yaml.js";
import zephirLang from "highlight.js/lib/languages/zephir.js";

export type HighlightLanguageFn = (hljs: unknown) => unknown;

// Canonical highlight.js language name -> language definition factory.
export const HIGHLIGHT_LANGUAGE_MODULES: Record<string, HighlightLanguageFn> = {
	"1c": _1cLang,
	abnf: abnfLang,
	accesslog: accesslogLang,
	actionscript: actionscriptLang,
	ada: adaLang,
	angelscript: angelscriptLang,
	apache: apacheLang,
	applescript: applescriptLang,
	arcade: arcadeLang,
	arduino: arduinoLang,
	armasm: armasmLang,
	xml: xmlLang,
	asciidoc: asciidocLang,
	aspectj: aspectjLang,
	autohotkey: autohotkeyLang,
	autoit: autoitLang,
	avrasm: avrasmLang,
	awk: awkLang,
	axapta: axaptaLang,
	bash: bashLang,
	basic: basicLang,
	bnf: bnfLang,
	brainfuck: brainfuckLang,
	"c-like": c_likeLang,
	c: cLang,
	cal: calLang,
	capnproto: capnprotoLang,
	ceylon: ceylonLang,
	clean: cleanLang,
	clojure: clojureLang,
	"clojure-repl": clojure_replLang,
	cmake: cmakeLang,
	coffeescript: coffeescriptLang,
	coq: coqLang,
	cos: cosLang,
	cpp: cppLang,
	crmsh: crmshLang,
	crystal: crystalLang,
	csharp: csharpLang,
	csp: cspLang,
	css: cssLang,
	d: dLang,
	markdown: markdownLang,
	dart: dartLang,
	delphi: delphiLang,
	diff: diffLang,
	django: djangoLang,
	dns: dnsLang,
	dockerfile: dockerfileLang,
	dos: dosLang,
	dsconfig: dsconfigLang,
	dts: dtsLang,
	dust: dustLang,
	ebnf: ebnfLang,
	elixir: elixirLang,
	elm: elmLang,
	ruby: rubyLang,
	erb: erbLang,
	"erlang-repl": erlang_replLang,
	erlang: erlangLang,
	excel: excelLang,
	fix: fixLang,
	flix: flixLang,
	fortran: fortranLang,
	fsharp: fsharpLang,
	gams: gamsLang,
	gauss: gaussLang,
	gcode: gcodeLang,
	gherkin: gherkinLang,
	glsl: glslLang,
	gml: gmlLang,
	go: goLang,
	golo: goloLang,
	gradle: gradleLang,
	groovy: groovyLang,
	haml: hamlLang,
	handlebars: handlebarsLang,
	haskell: haskellLang,
	haxe: haxeLang,
	hsp: hspLang,
	htmlbars: htmlbarsLang,
	http: httpLang,
	hy: hyLang,
	inform7: inform7Lang,
	ini: iniLang,
	irpf90: irpf90Lang,
	isbl: isblLang,
	java: javaLang,
	javascript: javascriptLang,
	"jboss-cli": jboss_cliLang,
	json: jsonLang,
	julia: juliaLang,
	"julia-repl": julia_replLang,
	kotlin: kotlinLang,
	lasso: lassoLang,
	latex: latexLang,
	ldif: ldifLang,
	leaf: leafLang,
	less: lessLang,
	lisp: lispLang,
	livecodeserver: livecodeserverLang,
	livescript: livescriptLang,
	llvm: llvmLang,
	lsl: lslLang,
	lua: luaLang,
	makefile: makefileLang,
	mathematica: mathematicaLang,
	matlab: matlabLang,
	maxima: maximaLang,
	mel: melLang,
	mercury: mercuryLang,
	mipsasm: mipsasmLang,
	mizar: mizarLang,
	perl: perlLang,
	mojolicious: mojoliciousLang,
	monkey: monkeyLang,
	moonscript: moonscriptLang,
	n1ql: n1qlLang,
	nginx: nginxLang,
	nim: nimLang,
	nix: nixLang,
	"node-repl": node_replLang,
	nsis: nsisLang,
	objectivec: objectivecLang,
	ocaml: ocamlLang,
	openscad: openscadLang,
	oxygene: oxygeneLang,
	parser3: parser3Lang,
	pf: pfLang,
	pgsql: pgsqlLang,
	php: phpLang,
	"php-template": php_templateLang,
	plaintext: plaintextLang,
	pony: ponyLang,
	powershell: powershellLang,
	processing: processingLang,
	profile: profileLang,
	prolog: prologLang,
	properties: propertiesLang,
	protobuf: protobufLang,
	puppet: puppetLang,
	purebasic: purebasicLang,
	python: pythonLang,
	"python-repl": python_replLang,
	q: qLang,
	qml: qmlLang,
	r: rLang,
	reasonml: reasonmlLang,
	rib: ribLang,
	roboconf: roboconfLang,
	routeros: routerosLang,
	rsl: rslLang,
	ruleslanguage: ruleslanguageLang,
	rust: rustLang,
	sas: sasLang,
	scala: scalaLang,
	scheme: schemeLang,
	scilab: scilabLang,
	scss: scssLang,
	shell: shellLang,
	smali: smaliLang,
	smalltalk: smalltalkLang,
	sml: smlLang,
	sqf: sqfLang,
	sql_more: sql_moreLang,
	sql: sqlLang,
	stan: stanLang,
	stata: stataLang,
	step21: step21Lang,
	stylus: stylusLang,
	subunit: subunitLang,
	swift: swiftLang,
	taggerscript: taggerscriptLang,
	yaml: yamlLang,
	tap: tapLang,
	tcl: tclLang,
	thrift: thriftLang,
	tp: tpLang,
	twig: twigLang,
	typescript: typescriptLang,
	vala: valaLang,
	vbnet: vbnetLang,
	vbscript: vbscriptLang,
	"vbscript-html": vbscript_htmlLang,
	verilog: verilogLang,
	vhdl: vhdlLang,
	vim: vimLang,
	x86asm: x86asmLang,
	xl: xlLang,
	xquery: xqueryLang,
	zephir: zephirLang,
};

// Alias name -> canonical highlight.js language name (mirrors the aliases each
// language module registers internally; last registration wins, matching the
// original highlight.js/lib/index.js registration order).
export const HIGHLIGHT_LANGUAGE_ALIASES: Record<string, string> = {
	as: "actionscript",
	asc: "angelscript",
	apacheconf: "apache",
	osascript: "applescript",
	ino: "arduino",
	arm: "armasm",
	html: "xml",
	xhtml: "xml",
	rss: "xml",
	atom: "xml",
	xjb: "xml",
	xsd: "xml",
	xsl: "xml",
	plist: "xml",
	wsf: "xml",
	svg: "xml",
	adoc: "asciidoc",
	ahk: "autohotkey",
	"x++": "axapta",
	sh: "bash",
	zsh: "bash",
	bf: "brainfuck",
	c: "c-like",
	h: "c",
	cc: "cpp",
	"c++": "cpp",
	"h++": "cpp",
	hpp: "cpp",
	hh: "cpp",
	hxx: "cpp",
	cxx: "cpp",
	capnp: "capnproto",
	icl: "clean",
	dcl: "clean",
	clj: "clojure",
	"cmake.in": "cmake",
	coffee: "coffeescript",
	cson: "coffeescript",
	iced: "coffeescript",
	cls: "cos",
	crm: "crmsh",
	pcmk: "crmsh",
	cr: "crystal",
	cs: "csharp",
	"c#": "csharp",
	md: "markdown",
	mkdown: "markdown",
	mkd: "markdown",
	dpr: "delphi",
	dfm: "delphi",
	pas: "delphi",
	pascal: "delphi",
	freepascal: "delphi",
	lazarus: "delphi",
	lpr: "delphi",
	lfm: "delphi",
	patch: "diff",
	jinja: "django",
	bind: "dns",
	zone: "dns",
	docker: "dockerfile",
	bat: "dos",
	cmd: "dos",
	dst: "dust",
	rb: "ruby",
	gemspec: "ruby",
	podspec: "ruby",
	thor: "ruby",
	irb: "ruby",
	erl: "erlang",
	xlsx: "excel",
	xls: "excel",
	f90: "fortran",
	f95: "fortran",
	fs: "fsharp",
	gms: "gams",
	gss: "gauss",
	nc: "gcode",
	feature: "gherkin",
	golang: "go",
	hbs: "htmlbars",
	"html.hbs": "htmlbars",
	"html.handlebars": "htmlbars",
	htmlbars: "handlebars",
	hs: "haskell",
	hx: "haxe",
	https: "http",
	hylang: "hy",
	i7: "inform7",
	toml: "ini",
	jsp: "java",
	js: "javascript",
	jsx: "javascript",
	mjs: "javascript",
	cjs: "javascript",
	"wildfly-cli": "jboss-cli",
	kt: "kotlin",
	kts: "kotlin",
	ls: "livescript",
	lassoscript: "lasso",
	tex: "latex",
	mk: "makefile",
	mak: "makefile",
	make: "makefile",
	mma: "mathematica",
	wl: "mathematica",
	m: "mercury",
	moo: "mercury",
	mips: "mipsasm",
	pl: "perl",
	pm: "perl",
	moon: "moonscript",
	nginxconf: "nginx",
	nixos: "nix",
	mm: "objectivec",
	objc: "objectivec",
	"obj-c": "objectivec",
	"obj-c++": "objectivec",
	"objective-c++": "objectivec",
	ml: "sml",
	scad: "openscad",
	"pf.conf": "pf",
	postgres: "pgsql",
	postgresql: "pgsql",
	php3: "php",
	php4: "php",
	php5: "php",
	php6: "php",
	php7: "php",
	php8: "php",
	text: "plaintext",
	txt: "plaintext",
	ps: "powershell",
	ps1: "powershell",
	pp: "puppet",
	pb: "purebasic",
	pbi: "purebasic",
	py: "python",
	gyp: "python",
	ipython: "python",
	pycon: "python-repl",
	k: "q",
	kdb: "q",
	qt: "qml",
	re: "reasonml",
	graph: "roboconf",
	instances: "roboconf",
	mikrotik: "routeros",
	rs: "rust",
	sci: "scilab",
	console: "shell",
	st: "smalltalk",
	mysql: "sql_more",
	oracle: "sql_more",
	stanfuncs: "stan",
	do: "stata",
	ado: "stata",
	p21: "step21",
	step: "step21",
	stp: "step21",
	styl: "stylus",
	yml: "yaml",
	tk: "tcl",
	craftcms: "twig",
	ts: "typescript",
	tsx: "typescript",
	vb: "vbnet",
	vbs: "vbscript",
	v: "verilog",
	sv: "verilog",
	svh: "verilog",
	tao: "xl",
	xpath: "xquery",
	xq: "xquery",
	zep: "zephir",
};
